import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AppProvider } from './contexts/AppContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import { AuthProvider } from './components/ProtectedRoute';
import NotificationContainer from './components/NotificationContainer';

// Lazy load pages for better performance
const LandingPage = lazy(() => import('./pages/LandingPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Announcements = lazy(() => import('./pages/Announcements'));
const SeminarWorkflow = lazy(() => import('./pages/SeminarWorkflow'));
const Cana101 = lazy(() => import('./pages/Cana101'));
const Certificate = lazy(() => import('./pages/Certificate'));
const NotFound = lazy(() => import('./pages/NotFound'));
const DesignShowcase = lazy(() => import('./components/DesignShowcase'));
const AddUsers = lazy(() => import('./components/AddUsers'));

export default function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <AppProvider>
          <NotificationsProvider>
            <Router>
              <div className="min-h-screen bg-white">
                <Suspense fallback={
                  <div className="min-h-screen flex items-center justify-center bg-white">
                    <div className="text-2xl font-bold text-green-700 animate-pulse">Loading...</div>
                  </div>
                }>
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/showcase" element={<DesignShowcase />} />

                  {/* Protected Application Routes with Layout */}
                  <Route path="/Dashboard" element={
                    <ProtectedRoute>
                      <Layout>
                        <Cana101 />
                      </Layout>
                    </ProtectedRoute>
                  } />

                  <Route path="/dashboard" element={
                    <ProtectedRoute>
                      <Layout>
                        <Cana101 />
                      </Layout>
                    </ProtectedRoute>
                  } />

                  <Route path="/Certificates" element={
                    <ProtectedRoute>
                      <Layout>
                        <Dashboard />
                      </Layout>
                    </ProtectedRoute>
                  } />

                  <Route path="/BasicBibleSeminar" element={
                    <ProtectedRoute>
                      <Layout>
                        <Dashboard />
                      </Layout>
                    </ProtectedRoute>
                  } />

                  <Route path="/AddUsers" element={
                    <ProtectedRoute requiredRole="admin">
                      <Layout>
                        <AddUsers />
                      </Layout>
                    </ProtectedRoute>
                  } />
                  <Route path="/seminar" element={
                    <ProtectedRoute>
                      <Layout>
                        <SeminarWorkflow />
                      </Layout>
                    </ProtectedRoute>
                  } />
                  <Route path="/Announcements" element={
                    <ProtectedRoute requiredRole="admin">
                      <Layout>
                        <Announcements />
                      </Layout>
                    </ProtectedRoute>
                  } />
                  <Route path="/Announcements" element={
                    <ProtectedRoute requiredRole="admin">
                      <Layout>
                        <Announcements />
                      </Layout>
                    </ProtectedRoute>
                  } />

                  <Route path="/bbs" element={
                    <ProtectedRoute>
                      <Layout>
                        <Dashboard />
                      </Layout>
                    </ProtectedRoute>
                  } />

                  <Route path="/certificate/:id" element={
                    <ProtectedRoute>
                      <Layout>
                        <Certificate />
                      </Layout>
                    </ProtectedRoute>
                  } />

                  {/* 404 Page */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>

              {/* Global Toast Notifications */}
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: 'hsl(var(--card))',
                    color: 'hsl(var(--card-foreground))',
                    border: '1px solid hsl(var(--border))',
                  },
                }}
              />

              {/* Inline Notifications Container */}
              <NotificationContainer position="top-right" />
            </div>
            </Router>
          </NotificationsProvider>
        </AppProvider>
      </ErrorBoundary>
    </AuthProvider>
  );
}

